import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { QuotaService } from '../../features/quotas/services/quota.service';
import * as QuotaActions from './quota.actions';

@Injectable()
export class QuotaEffects {
  private actions$ = inject(Actions);
  private quotaService = inject(QuotaService);

  loadQuotaSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(QuotaActions.loadQuotaSummary),
      switchMap(() =>
        this.quotaService.getAllQuotas({ page: 1, size: 100 }).pipe(
          map((response) => {
            if (response.success) {
              return QuotaActions.loadQuotaSummarySuccess({ quotas: response.res.content });
            }
            return QuotaActions.loadQuotaSummaryFailure({ error: response.msg || 'Ошибка загрузки' });
          }),
          catchError((error) =>
            of(QuotaActions.loadQuotaSummaryFailure({ error: error.message }))
          )
        )
      )
    )
  );
}
